module.exports = __webpack_public_path__ + "img/piaget-altiplano-ultimate-910p-1.e626cafc.png";